import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BudgetCategoryGroupContainerModel } from "../../../../../../models/aggregates/erp/financial/budget-category-group-container.model";

@Injectable({
  providedIn: "root",
})
export class BudgetCategoryGroupService extends BaseApiTemplateService<BudgetCategoryGroupContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/category/groups/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget/category/groups/backoffice-ep";
    this.httpClient = http;
  }
}
